import { render } from "./ResultadoFile.vue?vue&type=template&id=2a87d1fb&scoped=true"
import script from "./ResultadoFile.vue?vue&type=script&lang=js"
export * from "./ResultadoFile.vue?vue&type=script&lang=js"

import "./ResultadoFile.vue?vue&type=style&index=0&id=2a87d1fb&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a87d1fb"]])

export default __exports__